import React from 'react';
import Header from '../components/Header';
import Hero from './Hero';
import QuickAccess from './QuickAccess';
import Publications from './Publications';
import Footer from '../components/Footer';
import useSEO from '../components/SEO';

const Home: React.FC = () => {

  // SEO pour la page d'accueil
  useSEO({
    title: "ISTMECH - Institut Supérieur de Technologie Médicale du Cap-Haïtien",
    description: "Formation d'excellence en technologie médicale depuis 1984. 224+ diplômés, meilleure école de technologie médicale d'Haïti. Admission, programmes et contact.",
    keywords: "ISTMECH, technologie médicale, formation médicale, Cap-Haïtien, Haïti, biologie médicale, analyses cliniques, technologiste médical, école médicale, admission, diplôme",
    url: "https://www.istmech.edu.ht/",
    image: "https://www.istmech.edu.ht/og-image.png"
  });

  return (
    <div className="App">
      <Header />
      <Hero />
      <QuickAccess />
      <Publications />
      <Footer />
    </div>
  );
};

export default Home;
